import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Model } from '@legacymodels';
import { cloneDeep } from 'lodash';
import { NgClass, LowerCasePipe } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-filters-checkbox',
  templateUrl: './filters-checkbox.component.html',
  styleUrls: ['./filters-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, MatCheckbox, FormsModule, MatButton, LowerCasePipe],
})
export class FiltersCheckboxComponent implements OnInit {
  @Input() public filterTitle: string;
  @Input() public filterOptions: Model.CategoryOptions[];
  @Input() public rightJustify: boolean;
  @Output() public applyFilter = new EventEmitter();
  @Output() public closePopUp = new EventEmitter();

  public options: Model.CategoryOptions[] = [];

  public ngOnInit(): void {
    this.setDefaultValue();
  }

  public canApplyFilter(): boolean {
    return this.options.some((o) => o.checked) || this.filterOptions.some((o) => o.checked);
  }

  public clearFilter(): void {
    this.options.forEach((o) => (o.checked = false));
    this.applyFilter.emit([]);
  }

  public apply(): void {
    const filtersChecked = this.options.filter((o) => o.checked);
    this.applyFilter.emit(filtersChecked);
  }

  private setDefaultValue(): void {
    this.options = cloneDeep(this.filterOptions);
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    if (targetElement) {
      if (
        targetElement.tagName === 'HTML' ||
        (!targetElement.classList.contains('active-filter-link') &&
          !targetElement.classList.contains('btn-light') &&
          !targetElement.classList.contains('no-border-btn') &&
          !targetElement.offsetParent?.classList.contains('filter-button') &&
          !targetElement.offsetParent?.classList.contains('filter-container') &&
          !targetElement.offsetParent?.classList.contains('mdc-checkbox') &&
          !targetElement.classList.contains('mat-button-wrapper') &&
          !targetElement.classList.contains('mat-radio-outer-circle') &&
          !targetElement.classList.contains('mat-radio-inner-circle') &&
          !targetElement.offsetParent.classList.contains('filter-category') &&
          !targetElement.offsetParent.classList.contains('mat-form-field-infix') &&
          !targetElement.offsetParent.classList.contains('mat-form-field-wrapper') &&
          !targetElement.offsetParent.classList.contains('dropdown-menu') &&
          !targetElement.classList.contains('ngb-dp-month-name') &&
          !targetElement.classList.contains('ngb-dp-arrow-btn'))
      ) {
        this.closePopUp.emit();
      }
    }
  }
}
